// src/PrivacyPage.jsx
import React from 'react';
import { useTranslation } from 'react-i18next';

export default function PrivacyPage({ onBack }) {
  const { t } = useTranslation();
  const sections = t('privacy.s', { returnObjects: true });

  return (
    <div style={{minHeight:'100vh',background:'#07070a',color:'#f0ece4',fontFamily:'Inter, sans-serif',padding:'40px 24px'}}>
      <div style={{maxWidth:'760px',margin:'0 auto'}}>

        <div style={{marginBottom:'40px'}}>
          {onBack && (
            <button onClick={onBack} style={{background:'transparent',border:'none',color:'#d4a550',fontFamily:'Kanit, sans-serif',fontSize:'13px',letterSpacing:'0.08em',cursor:'pointer',marginBottom:'24px',padding:0,textTransform:'uppercase'}}>
              {t('privacy.back')}
            </button>
          )}
          <div style={{fontFamily:'Kanit, sans-serif',fontSize:'11px',letterSpacing:'0.2em',color:'#d4a550',textTransform:'uppercase',marginBottom:'8px'}}>
            {t('privacy.eyebrow')}
          </div>
          <h1 style={{fontFamily:'Kanit, sans-serif',fontWeight:800,fontSize:'32px',margin:0,letterSpacing:'-0.02em'}}>
            {t('privacy.title')}
          </h1>
          <p style={{color:'#8a8a9a',fontSize:'13px',marginTop:'8px'}}>{t('privacy.date')}</p>
        </div>

        {Array.isArray(sections) && sections.map((s, i) => (
          <div key={i} style={{marginBottom:'36px'}}>
            <h2 style={{fontFamily:'Kanit, sans-serif',fontWeight:700,fontSize:'16px',letterSpacing:'0.05em',color:'#d4a550',textTransform:'uppercase',margin:'0 0 12px 0',borderBottom:'1px solid rgba(212,165,80,0.15)',paddingBottom:'8px'}}>
              {s.t}
            </h2>
            <p style={{fontSize:'14px',lineHeight:1.8,color:'#b0adb8',whiteSpace:'pre-line',margin:0}}>
              {s.c}
            </p>
          </div>
        ))}

        <div style={{marginTop:'48px',paddingTop:'24px',borderTop:'1px solid rgba(255,255,255,0.07)',textAlign:'center'}}>
          <span style={{fontFamily:'Kanit, sans-serif',fontSize:'18px',fontWeight:800,letterSpacing:'0.1em',color:'#d4a550'}}>JKL</span>
          <p style={{color:'#4a4a5a',fontSize:'12px',marginTop:'8px'}}>{t('privacy.footer')}</p>
        </div>

      </div>
    </div>
  );
}
